import { t } from '../../shared/config/translations'
import { haptic } from '../utils/haptics'
import { showSnackbar } from './Snackbar'

type NativeRefreshWindow = Window & {
	tunetossRefresh?: () => Promise<boolean>
	webkit?: {
		messageHandlers?: {
			tunetossRefreshAvailability?: { postMessage(value: boolean): void }
			tunetossRefreshTitle?: { postMessage(value: string): void }
		}
	}
}

/** Shell-owned input only; pages and the store own the actual refresh. */
export class NativeRefreshControl {
	private enabled = false
	private busy = false
	private requestId = 0
	private disposed = false
	private title = ''

	constructor(private readonly refresh: () => Promise<void>) {
		const nativeWindow = window as NativeRefreshWindow
		nativeWindow.tunetossRefresh = () => this.run()
		this.setState(false, false)
	}

	setState(enabled: boolean, busy: boolean): void {
		this.enabled = enabled
		this.busy = busy
		this.setNativeAvailability(enabled)
	}

	/** Text under the native spinner; only visible while pulling. */
	setTitle(title: string): void {
		if (title === this.title || this.disposed) return
		this.title = title
		const nativeWindow = window as NativeRefreshWindow
		nativeWindow.webkit?.messageHandlers?.tunetossRefreshTitle?.postMessage(
			title,
		)
	}

	cancel(): void {
		this.requestId++
		this.setNativeAvailability(false)
	}

	private setNativeAvailability(available: boolean): void {
		const nativeWindow = window as NativeRefreshWindow
		nativeWindow.webkit?.messageHandlers?.tunetossRefreshAvailability?.postMessage(
			available,
		)
	}

	private async run(): Promise<boolean> {
		if (!this.enabled || this.busy || this.disposed) return false
		if (document.querySelector('.overlay-active, dialog[open]'))
			return false
		const requestId = ++this.requestId
		void haptic('threshold')
		try {
			await this.refresh()
			return true
		} catch {
			if (requestId === this.requestId && !this.disposed)
				showSnackbar(t('refresh.failed'), 'error')
			return false
		}
	}

	dispose(): void {
		this.disposed = true
		this.cancel()
		delete (window as NativeRefreshWindow).tunetossRefresh
	}
}
